// Minimal service worker registration (installability + offline fallback).
// Never caches /api responses — see public/sw.js.

if (typeof navigator !== "undefined" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
